// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"444":"15763883","517":"cdfda08b","618":"15763883","745":"15763883"}[chunkId] + ".chunk.css";
};